import { render } from "./Index.vue?vue&type=template&id=b79d3d9a&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=b79d3d9a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b79d3d9a"

export default script